import { hashFnv32a } from '@/src/javascripts/script.js'
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const loginApp = document.getElementById('login-app')
  if (loginApp && !loginApp.__vue_app__) {
    createApp({
      components: { BaseAlert },
      methods: {
        onLogin (event) {
          event.preventDefault()
          const hashpwd = hashFnv32a(
            document.getElementById('login_password').value,
            true
          )
          document.getElementById('login_password').value = hashpwd
          event.target.submit()
        }
      },
      mounted () {
        this.$refs.account.focus()
      }
    }).mount(loginApp)
  }
})
